import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
import { DeleteAccount } from './pages/DeleteAccount';
export function App() {
  return <Routes data-id="element-0" data-mp="2mmvl6uoc8gbj">
      <Route path="/" element={<Home data-id="element-2" data-mp="2mjpvbd7vxaer" />} data-id="element-1" data-mp="2mn5a0exnchfn" />
      <Route path="/cookie-policy" element={<CookiePolicy data-id="element-4" data-mp="31ayv2f5i4c5m" />} data-id="element-3" data-mp="31aqeac69cmp5" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" data-mp="2wk0b95lb0vxm" />} data-id="element-5" data-mp="31c9tdzg6grpc" />
      <Route path="/terms" element={<TermsAndConditions data-id="element-8" data-mp="2wiffjcn976y6" />} data-id="element-7" data-mp="2wjqhd6x524mn" />
      <Route path="/disclaimer" element={<Disclaimer data-id="element-10" data-mp="28tmex2vosax8" />} data-id="element-9" data-mp="2wi5l9cv6edmo" />
      <Route path="/contact" element={<Contact data-id="element-12" data-mp="28sbad0uf2z52" />} data-id="element-11" data-mp="28t4l0cwhy8sh" />
      <Route path="/faq" element={<FAQ data-id="element-14" data-mp="23w4ek0vqj40u" />} data-id="element-13" data-mp="23vcmh01cjofb" />
      <Route path="/about" element={<About data-id="element-16" data-mp="23t8g8bfz6dbv" />} data-id="element-15" data-mp="23ujlygszdv5m" />
      <Route path="/delete-account" element={<DeleteAccount data-id="element-18" data-mp="3iiwf2oflbi38" />} data-id="element-17" data-mp="3ijxo6nd1puib" />
    </Routes>;
}